<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_CTV_ASSIGN_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Merchant cộng tác viên</h1>
      <div class="btn-group float-right">
        <button @click="toHistory" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-plus-circle"></i> Lịch sử gán
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <label>Tìm kiếm</label>
            <input
              type="text"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              v-model.trim="search.textSearch"
            />
          </div>
          <div class="form-group">
            <label>Thời gian tạo</label>
            <DateRangePicker
              placeholder="Thời gian"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center pt-1">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <label>Thời gian dự kiến</label>
            <DateRangePicker
              placeholder="Thời gian"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange1"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center pt-1">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <label>Loại agency</label>
            <Select2 placeholder="Loại agency" :options="agencyType" v-model="search.agentGroup" />
          </div>
          <div class="form-group">
            <label>Vùng kinh doanh</label>
            <Select2
              placeholder="Vùng kinh doanh"
              v-model="search.regionId"
              :options="dataRegion"
              @change="queryProvince($event)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <label>Tỉnh/Thành phố</label>
            <Select2
              placeholder="Tỉnh/Thành phố"
              v-model="search.cityCode"
              :options="dataProvince"
            ></Select2>
          </div>
          <div class="form-group">
            <label>Cộng tác viên</label>
            <Select2
              placeholder="Cộng tác viên"
              v-model="search.agentId"
              :options="dataCTV"
            ></Select2>
          </div>
          <div class="form-group">
            <label>Sale chăm sóc</label>
            <Select2
              placeholder="Sale chăm sóc"
              v-model="search.activeSaleId"
              :options="dataSaleSearch"
            ></Select2>
          </div>
          <div class="d-inline-block m-t-23 w-100">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 m-b-10 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              @click="removeForm"
              class="btn btn-outline-light hc-37 mr-2 m-b-10 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              class="btn btn-info hc-37 mr-2 m-b-10 pt-2 file-input"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title=""
              data-original-title="Xuất Excel"
              @click="exportExcel"
            >
              <i class="bx bx-download"></i><span>&nbsp;</span>Xuất Excel
            </button>
            <button
              v-if="
                selected.length > 0 &&
                dataPermission &&
                dataPermission.includes('CNPS_CSTM_MERCHANT_CTV_ASSIGN')
              "
              @click="confirmAssign"
              type="button"
              class="btn btn-primary hc-37 mr-2 m-b-10 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <span>&nbsp;</span>Gán MC
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="table-responsive">
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th width="50">
                    <div class="checkbox text-center">
                      <input type="checkbox" v-model="selectAll" />
                    </div>
                  </th>
                  <th scope="col" class="text-center">Thời gian</th>
                  <th scope="col" class="text-center">Merchant</th>
                  <th scope="col" class="text-center">Ngành nghề</th>
                  <th scope="col" class="text-center">Cộng tác viên</th>
                  <th scope="col" class="text-center">Sale chăm sóc</th>
                  <th scope="col" class="text-center">Loại agency</th>
                  <th scope="col" class="text-center">Tỉnh/thành phố</th>
                  <th scope="col" class="text-center">Thao tác</th>
                </tr>
              </thead>

              <tbody v-if="loading">
                <tr>
                  <td colspan="11" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr class="table-row" v-for="(item, index) in dataMC" :key="index">
                  <td>
                    <input type="checkbox" v-model="selected" :value="item" number />
                  </td>
                  <td>
                    <div v-if="item.createdDate">
                      <b>Tạo: </b>{{ item.createdDate | formatDate('HH:mm') }},
                      {{ item.createdDate | formatDate }} <br />
                    </div>
                    <div v-if="item.expectedSignDate">
                      <b>Dự kiến: </b>{{ item.expectedSignDate | formatDate }} <br />
                    </div>
                    <div v-if="item.modifiedDate">
                      <b>Cập nhật: </b>{{ item.modifiedDate | formatDate('HH:mm') }},
                      {{ item.modifiedDate | formatDate }}
                    </div>
                  </td>
                  <td>
                    <b>{{ item.merchantName }}</b> <br />
                    {{ item.mobile }} <br />
                    <a href="#">{{ item.email }}</a>
                  </td>
                  <td>{{ item.mccName }}</td>
                  <td>
                    {{ item.agentName }} <br />
                    {{ item.agentMobile }} <br />
                    <a href="#">{{ item.agentEmail }}</a>
                  </td>
                  <td>
                    <b>{{ item.activeSaleName }}</b
                    ><br />
                    <a href="#">{{ item.activeSaleEmail }}</a>
                  </td>
                  <td>{{ item.agentGroup }}</td>
                  <td>{{ item.district }}, {{ item.city }}</td>
                  <td class="text-right">
                    <div class="dropdown show float-right">
                      <button
                        type="button"
                        class="btn btn-outline-light btn-sm dropdown-toggle ml-1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="sr-only">More</span>
                      </button>
                      <div class="dropdown-menu">
                        <button @click="mcDetail(item)" class="dropdown-item">
                          <i class="bx bx-show-alt"></i> Chi tiết
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
    <!--Modal chọn sale-->
    <b-modal id="modal-scoped" v-model="showListSale">
      <template #modal-header="{ close }">
        <h5>Chọn sale</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <p>Hãy nhập tên sale nhận MC</p>
      <vue-simple-suggest
        display-attribute="text1"
        value-attribute="id"
        :list="dataSale"
        :filter-by-query="true"
        @select="onSuggestSelect"
      >
      </vue-simple-suggest>

      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
        <b-button
          size="sm"
          variant="primary"
          @click="submitAssign()"
          v-if="dataPermission && dataPermission.includes('CNPS_CSTM_MERCHANT_CTV_UPDATE')"
        >
          Xác nhận
        </b-button>
      </template>
    </b-modal>
    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import { StaffService } from '@/services/staff.service'
  import VueSimpleSuggest from 'vue-simple-suggest'
  import 'vue-simple-suggest/dist/styles.css'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import Config from '@/thirdParty/config'

  export default {
    mixins: [prepareQueryParamsMixin],
    components: {
      VueSimpleSuggest,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem('userData')),
        dataMC: [],
        search: {
          limit: 50,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataCTV: [],
        dataRegion: [],
        dataProvince: [],
        dataSale: [],
        dataSaleSearch: [],
        selected: [],
        notiModal: false,
        iconNoti: '',
        msgNoti: '',
        saleInfo: {},
        showListSale: false,
        agencyType: [
          { id: 'MSB', text: 'MSB' },
          { id: 'NEXTPAY', text: 'NEXTPAY' },
        ],
        localeData: Config.localeData,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRange1: {
          startDate: null,
          endDate: null,
        },
        loading: false,
      }
    },
    async created() {
      this.loading = true
      await this.queryProvince(this.search.regionId)
      await this.listAgent()
      await this.getRegions()
      await this.getListStaffLower()
      await this.getListSale()
      this.fetchData()
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataMC ? this.selected.length === this.dataMC.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataMC.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    methods: {
      // chuyển trang lịch sử
      toHistory() {
        this.$router.push('history-assign-mc')
      },
      // chuyển màn chi tiết
      mcDetail(item) {
        this.$router.push({ path: `/assign-mc/${item.customerId}` })
      },
      // thời gian
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
        this.search.expectedSignStartDate = moment(this.dateRange1.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.expectedSignEndDate = moment(this.dateRange1.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      // lấy list CTV
      async listAgent() {
        try {
          const dataItem = await AgentService.listAgentForSearch()
          if (dataItem.success) {
            this.dataCTV = dataItem.data.map(e => {
              return { id: e.agentId, text: e.name }
            })
          }
        } catch (error) {}
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataRegion = data.data.map(e => {
            return { id: e.id, text: e.name }
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
      // list sale nhận
      async getListStaffLower(params) {
        try {
          const data = await StaffService.getListLowerGrade(params)
          if (data.data.length > 0) {
            this.dataSale = data.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
                regionIds: e.regionIds,
                email: e.userName,
                text1: e.name + ' - ' + e.userName,
              }
            })
          }
        } catch (error) {}
      },
      // list sale chăm sóc
      async getListSale() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userData.userId,
          })
          if (data.data.length > 0) {
            this.dataSaleSearch = data.data.map(e => {
              return { id: e.userId, text: e.name }
            })
            this.dataSaleSearch.shift()
          }
        } catch (error) {}
      },
      // Lọc
      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeForm() {
        this.search = {
          limit: 50,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRange1 = {
          startDate: null,
          endDate: null,
        }
        this.selected = []
        await this.fetchData()
      },
      // gán mc
      async confirmAssign() {
        // check list select xem mc có trùng vùng không
        const arr = this.selected.map(e => {
          return e.regionId
        })
        const isExist = (arr, x) => {
          for (const i in arr) {
            if (arr[i] === x) return true
          }
          return false
        }
        const ans = []
        arr.forEach(element => {
          if (!isExist(ans, element)) {
            ans.push(element)
          }
        })
        if (ans.length > 1) {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Merchant đã chọn không cùng vùng với nhau!'
          this.selected = []
          this.search.saleId = null
        } else {
          this.showListSale = true
          const params = {
            userId: this.userData.userId,
            region: ans,
          }
          this.getListStaffLower(params)
        }
      },
      onSuggestSelect(suggest) {
        this.search.saleId = suggest.id
        this.saleInfo = this.dataSale.find(a => a.id === this.search.saleId)
      },
      async submitAssign() {
        const assignData = []
        this.selected.map(e => assignData.push({ customerId: e.customerId }))
        try {
          const data = await AgentService.assignMerchant({
            assignData: assignData,
            assignerId: this.userData.userId,
            assignerEmail: this.userData.username,
            assignerName: this.userData.name,
            saleId: this.saleInfo.id,
            saleName: this.saleInfo.text,
            saleEmail: this.saleInfo.email,
          })
          if (data.success) {
            this.showListSale = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Gán thành công'
            this.selected = []
            this.fetchData()
          } else {
            this.showListSale = false
            this.notiModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.selected = []
          }
        } catch (error) {}
      },
      // dữ liệu bảng
      async fetchData() {
        try {
          this.loading = true
          const data = await AgentService.getAgencyListMC(this.search)
          if (data.success) {
            this.dataMC = data.data
            this.pagination.total = data.meta.pagination.total ? data.meta.pagination.total : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // xuất excel
      async exportExcel() {
        try {
          if (this.search.regionId === '0') this.search.regionId = null
          if (this.search.cityCode === '0') this.search.cityCode = null
          if (this.search.agentId === '0') this.search.agentId = null
          if (this.search.activeSaleId === '0') this.search.activeSaleId = null
          await AgentService.exportExcelMCAgent(this.search)
        } catch (error) {
          console.log(error)
        } finally {
        }
      },
    },
  }
</script>
